import { FC, useMemo } from "react";
import useBulkAction from "hooks/useBulkAction";
import { BulkAction, BulkActionProps } from "../BulkActionsControls/types";
import { trash2 } from "assets/icons";
import BulkActionsControlBase from "../BulkActionsControls/BulkActionsControlBase";
import useRemoveShare from "hooks/services/shares/useRemoveShare";
import { useTranslation } from "react-i18next";

const BlockBulkActionControl: FC<BulkActionProps> = (props) => {
  const { mutateAsync: deleteSharesAsync } = useRemoveShare();

  const { t } = useTranslation();

  const {
    bulkAction: deleteShareBulk,
    isLoading: isDeletingShareBulk,
    bulkResult: deleteShareBulkResult,
  } = useBulkAction(deleteSharesAsync);

  const actions: BulkAction[] = useMemo(
    () => [
      {
        name: t("Remove"),
        icon: trash2,
        confirmMessage: t("Are you sure you want to delete these blocks?"),
        bulkAction: deleteShareBulk,
        bulkActionLoading: isDeletingShareBulk,
        bulkActionResult: deleteShareBulkResult,
      },
    ],
    [deleteShareBulk, isDeletingShareBulk, deleteShareBulkResult]
  );
  return <BulkActionsControlBase {...props} actions={actions} />;
};

export default BlockBulkActionControl;
